import React, { Fragment } from 'react'

export default function MulticolorHeadline (props) {
    if (!props.headline) { return null }
    if (typeof props.headline !== 'string') { return null }
    
    const splittedHeadline = props.headline.split("[")

    return splittedHeadline.map((head, key) => {
        if (head.split("]").length > 1) {
            return (
                <Fragment key={key}>
                    <span
                        style={{ color: props.accentColor }}
                    >
                        {head.split("]")[0]}
                    </span>

                    <span>{head.split("]")[1]}</span>
                </Fragment>
            )
        } else {
            return (
                <span key={key}>{head}</span>
            )  
        }
    })
}
